module.exports = __webpack_public_path__ + "img/vertical_4_3_6000.7a4d2eaa.png";